import axios from "axios";
import { BASE_URL } from "./url";
import { withCache } from "../utils/apiCache";

const mApi = axios.create({
    withCredentials: true,
    baseURL: BASE_URL,
});

export const getDashboardTableData = async () =>
    withCache("dashboard/leads", async () => {
        try {
            const response = await mApi.get("/dashboard/leads");
            return response.data;
        } catch (error) {
            return error;
        }
    });

export const getDashboardSummary = async () =>
    withCache("dashboard/summary", async () => {
        try {
            const response = await mApi.get("/dashboard/summary");
            return response.data;
        } catch (error) {
            console.error("Error fetching dashboard summary:", error);
            return null;
        }
    });
